import { cwslapi } from "../index";




// 获取个人贡献榜
export const getPersonalContributionRankApi = (data) => {
  return cwslapi({
    url: "/guildVoteActivity/getPersonalContributionRank",
    method: "post",
    data,
  });
};



// 获取工会排行榜
export const getGuildRankListApi = (data) => {
    return cwslapi({
      url: "/guildVoteActivity/getGuildRankList",
      method: "post",
      data,
    });
  };
 


// 获取工会投票活动信息
export const getActivityInfoApi = (data) => {
    return cwslapi({
      url: "/guildVoteActivity/getActivityInfo",
      method: "post",
      data,
    });
  };



// 热力商店购买商品
export const buyHeatShopItemApi = (data) => {
    return cwslapi({
      url: "/guildVoteActivity/buyHeatShopItem",
      method: "post",
      data,
    });
  };




// 领取每日任务奖励
export const claimDailyTaskRewardApi = (data) => {
    return cwslapi({
      url: "/guildVoteActivity/claimDailyTaskReward",
      method: "post",
      data,
    });
  };


// 领取VIP福利
export const claimVipBonusApi = (data) => {
    return cwslapi({
      url: "/guildVoteActivity/claimVipBonus",
      method: "post",
      data,
    });
  };


// 工会投票
export const voteApi = (data) => {
    return cwslapi({
      url: "/guildVoteActivity/vote",
      method: "post",
      data,
    });
  };

